import { Button } from '@flippingbook/web.react-kit/dist/Button';
import { Paper } from '@flippingbook/web.react-kit/dist/Paper';

import { useRestoreUpdatePage } from '@/hooks/useRestoreUpdatePage';
import { loc } from '@/localization';
import { UserPasswordField } from '@/site/components/UserPasswordField';

import { b, e } from '../Login/style.css';

export function SetPage() {
    const { errors, isSubmitting, isSubmitted, validationRules, register, triggerValidation, watch, onFormSubmit } =
        useRestoreUpdatePage();

    return (
        <div className={b.name}>
            <Paper
                className={e.card}
                radius="large"
            >
                <h1 className={e.title}>{loc.Login.SetPasswordTitle}</h1>
                <p className={e.subtitle3}>{loc.Login.SetPasswordFormDescription}</p>
                <form
                    className={e.form}
                    onSubmit={onFormSubmit}
                    noValidate
                >
                    <UserPasswordField
                        className={e.emailField}
                        name="password"
                        placeholder={loc.Login.PasswordConfirmation}
                        register={register}
                        errors={errors}
                        triggerValidation={triggerValidation}
                        validationRules={validationRules}
                        readOnly={isSubmitting}
                        isSubmitted={isSubmitted}
                        watch={watch}
                    />
                    <div className={e.buttons}>
                        <Button
                            className={e.submitButton}
                            type="submit"
                            theme="green"
                            size="large"
                            progress={isSubmitting}
                            disabled={isSubmitting}
                        >
                            {loc.Login.DoSave}
                        </Button>
                    </div>
                </form>
            </Paper>
        </div>
    );
}
